import { render, staticRenderFns } from "./AvatarParticipationStatus.vue?vue&type=template&id=8f517566&scoped=true&"
import script from "./AvatarParticipationStatus.vue?vue&type=script&lang=js&"
export * from "./AvatarParticipationStatus.vue?vue&type=script&lang=js&"
import style0 from "./AvatarParticipationStatus.vue?vue&type=style&index=0&id=8f517566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f517566",
  null
  
)

export default component.exports